import { NavigationDrawerItemProps } from 'components/navigation_drawer/NavigationDrawerItem';
import { SecondaryNavigationItems } from 'components/navigation_drawer/SecondaryNavigationItems';
import { NavigationItemTitle } from 'components/navigation_drawer/styled';
import { StatelessPopup } from 'components/popup/stateless_popup/StatelessPopup';
import * as React from 'react';
import { tokens } from 'styles/tokens';

export type SecondaryNavigationPopupProps<TTriggerElem extends HTMLElement> = Readonly<{
    parentId: string;
    title: string;
    popupRef: React.RefObject<HTMLDivElement>;
    triggerRef: React.RefObject<TTriggerElem>;
    secondaryNavigationItems: NavigationDrawerItemProps[] | undefined;
    onClose: () => void;
}>;

export function SecondaryNavigationPopup<TTriggerElem extends HTMLElement>({
    parentId,
    title,
    popupRef,
    triggerRef,
    secondaryNavigationItems,
    onClose,
}: SecondaryNavigationPopupProps<TTriggerElem>) {
    const hasSubNavItems =
        secondaryNavigationItems && secondaryNavigationItems.some((item) => item.enabled);

    return (
        <StatelessPopup
            noPadding
            noPopupBackground
            noOverlay
            noPopupBorder
            popupClassName="navigation-popup"
            ref={popupRef}
            anchor={triggerRef.current}
            anchorAlign={{ horizontal: 'right', vertical: 'top' }}
            popupAlign={{ horizontal: 'left', vertical: 'top' }}
            popupSettings={{
                borderRadius: hasSubNavItems
                    ? '0 0.8rem 0.8rem 0.8rem'
                    : '0 0.8rem 0.8rem 0',
                style: {
                    boxShadow: tokens.nav.popupShadow,
                    width: '24rem',
                    backgroundColor: tokens.nav.popupBackground,
                },
            }}
            onClose={onClose}
        >
            <NavigationItemTitle
                $secondary
                style={{
                    height: tokens.nav.itemSize,
                    backgroundColor: tokens.nav.secondarySelected,
                    color: tokens.nav.textSelected,
                    borderRadius: hasSubNavItems ? '0 0.8rem 0 0' : '0 0.8rem 0.8rem 0',
                }}
            >
                {title}
            </NavigationItemTitle>
            {hasSubNavItems && (
                <SecondaryNavigationItems
                    parentId={parentId}
                    show
                    fitToScreenHeight
                    items={secondaryNavigationItems}
                />
            )}
        </StatelessPopup>
    );
}
